import React, { useState, useEffect } from "react";
import HeroSection from "./HeroSection";
import HowItWorks from "./HowItWorks";
import QuestionSection from "./QuestionSection";
import Register from "./Register";
import Login from "./Login";
import api from "../utils/api"; // Import your API utility

const Home = () => {
  const [showPopup, setShowPopup] = useState(null); // State to manage popup visibility ('login' or 'register')
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true); // New state to track loading

  useEffect(() => {
    // Check if the user is logged in
    const checkUserLoggedIn = async () => {
      try {
        const response = await api.get("/users/me"); // Adjust the API endpoint as needed
        if (response.status === 200) {
          setIsLoggedIn(true); // User is logged in
        }
      } catch (error) {
        console.error("User not logged in:", error);
        setIsLoggedIn(false); // User is not logged in
      } finally {
        setLoading(false); // Set loading to false after the check
      }
    };

    checkUserLoggedIn();
  }, []);

  useEffect(() => {
    // Show the popup after 10 seconds if the user is not logged in and loading is complete
    if (!loading && !isLoggedIn) {
      const timer = setTimeout(() => {
        setShowPopup("register"); // Show Register popup by default
      }, 2000);

      return () => clearTimeout(timer); // Cleanup timeout on component unmount
    }
  }, [isLoggedIn, loading]);

  const handleClosePopup = () => {
    setShowPopup(null);
  };

  return (
    <>
      <HeroSection />
      {/* <HowItWorks /> */}
      <QuestionSection />

      {/* Conditional Popups */}
      {showPopup === "register" && (
        <Register
          onClose={handleClosePopup} // Close Register popup
          showLogin={() => setShowPopup("login")} // Switch to Login popup
        />
      )}
      {showPopup === "login" && (
        <Login
          onClose={handleClosePopup} // Close Login popup
          showRegister={() => setShowPopup("register")} // Switch to Register popup
        />
      )}
    </>
  );
};

export default Home;